import React from 'react';
import SvgIcon from './SvgIcon';

function Logo() {
  return <SvgIcon name="logo" variant="none" />;
}

export default Logo;
